import TextInput, {TextInputWithoutContainer} from "../../../../component/TextInput/TextInput";
import {SelectWithoutContainer} from "../../../../component/Select/Select";
import {useState} from "react";
import DatePickerHeader from "react-multi-date-picker/plugins/date_picker_header";
import {PickDateTimeWithoutContainer} from "../../../../component/PickDate/PickDate";

const InstallmentHistoryForm = ({instalmentHistory, onChange}) => {

    const payOptions = [
        {
            label: "پرداخت نشده",
            value: "NOT_PAYED",
        },
        {
            label: "پرداخت شده",
            value: "PAYED",
        },

    ]
    const [tempValues, setTempValues] = useState({
        payStatus: instalmentHistory.payedTimestamp ? "PAYED" : "NOT_PAYED",
    })
    const changeInstallmentHistory = (key, value) => {
        onChange({...instalmentHistory, [key]: value})
    }


    return (
        <div className="card">
            <div className="card-body">
                <div className="row">
                    <div className="col-md-5 mb-4">
                        <TextInputWithoutContainer type={"number"} label={"مبلغ"} value={instalmentHistory.amount}
                                                   onChange={(value) => {
                                                       changeInstallmentHistory("amount", value)
                                                   }}/>
                    </div>

                    <div className="col-12 mb-4">
                        <div className="row">
                            <div className="col-md-5">
                                <PickDateTimeWithoutContainer label={"موعد پرداخت"}
                                                              timestamp={instalmentHistory.paymentTimestamp}
                                                              onChange={(value) => {
                                                                  changeInstallmentHistory("paymentTimestamp", value)
                                                              }}/>
                            </div>
                            <div className="col-md-2">
                                <SelectWithoutContainer label={"وضعیت پرداخت قسط"} options={payOptions}
                                                        value={tempValues.payStatus} onChange={(value) => {
                                    setTempValues({...tempValues, payStatus: value})
                                    if (value == "PAYED") {
                                        changeInstallmentHistory("payedTimestamp", Math.round(+new Date() / 1000))
                                    }
                                    if (value == "NOT_PAYED") {
                                        changeInstallmentHistory("payedTimestamp", "")
                                    }
                                }}/>
                            </div>
                            {tempValues.payStatus == "PAYED" && <div className="col-md-5">
                                <PickDateTimeWithoutContainer label={"زمان دریافت"}
                                                              timestamp={instalmentHistory.payedTimestamp}
                                                              onChange={(value) => {
                                                                  changeInstallmentHistory("payedTimestamp", value)
                                                              }}/>
                            </div>}
                        </div>
                    </div>

                    <div className="col-md-6">
                        <TextInputWithoutContainer label={"توضیح برای مشتری"} value={instalmentHistory.description}
                                                   onChange={(value) => {
                                                       changeInstallmentHistory("description", value)
                                                   }}/>
                    </div>
                    <div className="col-md-6">
                        <TextInputWithoutContainer label={"توضیح داخلی"} value={instalmentHistory.privateDescription}
                                                   onChange={(value) => {
                                                       changeInstallmentHistory("privateDescription", value)
                                                   }}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InstallmentHistoryForm;